import React from "react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footr = () => {
  return (
    <div className="bg-primary/90 shadow-md py-9 sm:py-6  dark:bg-gray-900 dark:text-white duration-200 relative z-40">
      <div className="flex justify-center space-x-4 mb-4">
        <a
          href="https://www.linkedin.com/company/iiche-avvu/"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white rounded-full w-10 h-10 flex items-center justify-center transition duration-300 transform hover:scale-110 hover:bg-gray-200 text-blue-700"
        >
          <FaLinkedin className="text-2xl" />
        </a>
        <a
          href="https://instagram.com/iiche_avvu?igshid=MzRlODBiNWFlZA=="
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white rounded-full w-10 h-10 flex items-center justify-center transition duration-300 transform hover:scale-110 hover:bg-gray-200 text-pink-600"
        >
          <FaInstagram className="text-2xl" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61550312694931&mibextid=ZbWKwL"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white rounded-full w-10 h-10 flex items-center justify-center transition duration-300 transform hover:scale-110 hover:bg-gray-200 text-blue-800"
        >
          <FaFacebook className="text-2xl" />
        </a>
      </div>
      <div className="container mx-auto text-center">
        <p className="text-sm sm:text-base text-gray-800 dark:text-gray-300">
          Copyright &copy; {new Date().getFullYear()}; IIChE AVVU - All Rights
          Reserved
        </p>
      </div>
    </div>
  );
};

export default Footr;
